export enum ClientTypeEnum {
  Individual,
  Entity,
  IndividualEntrepreneur,
}
